import React, { FC, useEffect, useState } from "react";
import { Box, Snackbar } from "@mui/material";
import { useGetProcessingStatusQuery } from "@store/photoApi";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";
import PhotosProcessingStatusAlert from "@components/PhotosProcessingStatusSnackbar/PhotosProcessingStatusAlert";
import { usePrevious } from "@hooks/usePrevious";

const POLLING_INTERVAL = 2_000;

const PhotosProcessingStatusSnackbar: FC = () => {
  const isUploading = useSelector(
    (state: RootState) => state.photoUpload.count > 0,
  );
  const prevIsUploading = usePrevious(isUploading);
  const [open, setOpen] = useState(false);
  const [pollingInterval, setPollingInterval] = useState(0);
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { data, refetch } = useGetProcessingStatusQuery(
    { patientId: selectedPatientId! },
    { skip: !selectedPatientId, pollingInterval, refetchOnFocus: true },
  );

  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });

  useEffect(() => {
    if (prevIsUploading && !isUploading) {
      refetch();
    }
  }, [refetch, prevIsUploading, isUploading]);

  useEffect(() => {
    setOpen(!!data?.pending);
    setPollingInterval(!!data?.pending ? POLLING_INTERVAL : 0);
  }, [data]);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: isSmScreen ? "bottom" : "top",
        horizontal: "center",
      }}
      open={open}
      ClickAwayListenerProps={{ onClickAway: () => null }}
      sx={{
        "&.MuiSnackbar-root": {
          top: isSmScreen ? null : "6px",
        },
      }}
    >
      <Box width="500px" display="flex">
        <PhotosProcessingStatusAlert count={data?.pending || 0} />
      </Box>
    </Snackbar>
  );
};

export default PhotosProcessingStatusSnackbar;
